<template>
  <a-modal
    :visible="modalVisible"
    @cancel="modalCancel"
    @ok="modalSubmit"
    width="50%"
    cancelText="取消"
    okText="确认"
    title="Anchor recommendation（主播推荐）"
  >
    <a-form
      ref="formRef"
      :model="form"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
      :rules="rules"
    >
      <a-form-item label="直播间号" name="liveId" required>
        <a-select
          v-model:value="form.liveId"
          placeholder="请选择"
          allow-clear
          :disabled="isEdit"
        >
          <a-select-option
            v-for="(item, index) in liveRoomSelect"
            :key="index"
            :value="item['id']"
            :label="item['chatGroupName']"
          >
            {{ item['chatGroupName'] }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="推荐主图" name="imgUrl">
        <UpdateImage
          v-if="modalVisible"
          :imageType="imageType"
          :defaultUrl="form.imgUrl"
          @setImgUrl="setImgUrl"
          @delActivityImg="delActivityImg"
        ></UpdateImage>
      </a-form-item>
      <!-- <a-form-item label="跳转链接" name="jumpLink">
        <a-input v-model:value="form.jumpLink" placeholder="请输入" />
      </a-form-item> -->
    </a-form>
  </a-modal>
</template>

<script>
import { inject, toRefs } from 'vue'
import UpdateImage from './UploadImg.vue'
export default {
  components: {
    UpdateImage
  },
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  color: #000;
}
.item {
  text-align: center;
  border: 1px solid #dedede;
  .label {
    padding: 10px 15px;
    white-space: nowrap;
  }
  .value {
    height: 100%;
    white-space: nowrap;
    padding: 10px 15px;
    border-top: 1px solid #dedede;
    .ant-form-item {
      margin: 0;
    }
  }
}
</style>
